export const DEDICATED_CHART_SLUGS = [
  "zec-vs-btc",
  "zec-vs-eth",
  "zec-vs-xmr",
  "zec-vs-gold",
  "zec-vs-sp500",
  "zec-vs-usd",
  "shielded-zcash",
] as const;

export type DedicatedChartSlug = (typeof DEDICATED_CHART_SLUGS)[number];

export function hasDedicatedChart(slug: string): slug is DedicatedChartSlug {
  return (DEDICATED_CHART_SLUGS as readonly string[]).includes(slug);
}

export function shouldShowShieldedPoolStats(slug: string): boolean {
  return slug === "shielded-zcash" || !hasDedicatedChart(slug);
}
